// errorReporting.js
// Utility for robust frontend error reporting in TeamIO

let errorLogTimestamps = [];
let errorSignatures = new Set();
const ERROR_LIMIT_PER_MINUTE = 5;
const ERROR_DEDUPLICATION_WINDOW_MS = 60 * 1000; // 1 minute

export function reportFrontendError(error, info = {}) {
    // Rate limiting
    const now = Date.now();
    errorLogTimestamps = errorLogTimestamps.filter(ts => now - ts < ERROR_DEDUPLICATION_WINDOW_MS);
    if (errorLogTimestamps.length >= ERROR_LIMIT_PER_MINUTE) {
        // Too many errors, skip reporting
        return;
    }

    // Deduplication
    const signature = `${error.message || error.toString()}|${error.stack || ''}`;
    if (errorSignatures.has(signature)) {
        return;
    }
    errorSignatures.add(signature);
    setTimeout(() => errorSignatures.delete(signature), ERROR_DEDUPLICATION_WINDOW_MS);

    errorLogTimestamps.push(now);

    // Gather context (no PHI)
    const context = {
        errorMessage: error.message || error.toString(),
        stack: error.stack || null,
        info,
        route: window.location.pathname,
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        timestamp: new Date().toISOString(),
    };

    // Use Vuex store if available
    if (window.__teamioVue__ && window.__teamioVue__.$store) {
        const p = window.__teamioVue__.$store.dispatch('forms/captureFormLogs', {
            logs: [{
                level: 'error',
                timestamp: context.timestamp,
                message: context.errorMessage,
                stack: context.stack,
                info: context.info,
                route: context.route,
                userAgent: context.userAgent,
                language: context.language,
                platform: context.platform,
            }],
            platform: {
                userAgent: context.userAgent,
                language: context.language,
                platform: context.platform,
                url: window.location.href,
                timestamp: context.timestamp
            }
        });
        // Prevent unhandled promise rejections from bubbling
        if (p && typeof p.catch === 'function') {
            p.catch((e) => {
                // Swallow network/store errors in the reporter itself
                console.warn('[errorReporting] captureFormLogs failed (non-fatal):', e && (e.message || e));
            });
        }
    } else {
        // Fallback: log to console
        console.error('Frontend error (not sent to backend):', context);
    }
} 